// extracted by mini-css-extract-plugin
export default {"title":"EmergingTechnologies_title__-BetQ"};